export class RequestBasis {

}
